const PLACEHOLDER = /^__[A-Z_]+__$/;

export function getRuntimeConfig(): RushdConsoleRuntimeConfig {
  const c = window.__RUSHD_CONSOLE_CONFIG__;
  if (!c) {
    throw new Error("runtime config not loaded — is /runtime-config.js included before the bundle?");
  }
  for (const [k, v] of Object.entries(c)) {
    if (typeof v === "string" && PLACEHOLDER.test(v)) {
      throw new Error(`runtime config placeholder unsubstituted: ${k}`);
    }
  }
  return c;
}

/** Where Cognito sends the person back: the address they are on, when the
 * configured list (comma-separated: the custom domain and CloudFront's own)
 * allows it, else the first one. Each must be a callback URL of the app client. */
export function redirectUriFor(configured: string, origin: string): string {
  const allowed = configured.split(",").map((u) => u.trim()).filter(Boolean);
  const here = `${origin.replace(/\/$/, "")}/`;
  return allowed.includes(here) ? here : allowed[0] ?? here;
}

export function redirectUri(): string {
  return redirectUriFor(getRuntimeConfig().cognitoRedirectUri, window.location.origin);
}
